<h1 mat-dialog-title>{{data.dialogType}} {{data.relationship}}</h1>
<div mat-dialog-content>
    <p> {{data.title}} </p>
    <mat-form-field>
        <input matInput [(ngModel)]="value" [placeholder]="data.placeholder?? 'New Master Key'"  [type]="data.type?? 'number'"/>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No</button>
    <button mat-button (click)="onYesClick()" [disabled]="value === null || value === 0" cdkFocusInitial>Yes</button>
</div>
